export class PaymentFakeData {
    public static payments = [
      {
        id: 1,
        fullName: 'Galen Slixby',
        subscriptionType: 'Standard',
        isPayment: 'Done',
      },
      {
        id: 2,
        fullName: 'Halsey Redmore',
        subscriptionType: 'Premium',
        isPayment: 'Done',
      },
      {
        id: 3,
        fullName: 'Marjory Sicely',
        subscriptionType: 'Free',
        isPayment: 'Not Done',
      },
      {
        id: 4,
        fullName: 'Cyrill Risby',
        subscriptionType: 'Premium',
        isPayment: 'Done',
      },
      {
        id: 5,
        fullName: 'Maggy Hurran',
        subscriptionType: 'Free',
        isPayment: 'Not Done',
      },
      {
        id: 6,
        fullName: 'Silvain Halstead',
        subscriptionType: 'Free',
        isPayment: 'Not Done',
      },
      {
        id: 7,
        fullName: 'Breena Gallemore',
        subscriptionType: 'Premium',
        isPayment: 'Pending',
      },
      {
        id: 8,
        fullName: 'Kathryne Liger',
        subscriptionType: 'Standard',
        isPayment: 'Done',
      },
      {
        id: 9,
        fullName: 'Franz Scotfurth',
        subscriptionType: 'Standard',
        isPayment: 'Done',
      },
      {
        id: 10,
        fullName: 'Jillene Bellany',
        subscriptionType: 'Premium',
        isPayment: 'Pending',
      },
      {
        id: 11,
        fullName: 'Jonah Wharlton',
        subscriptionType: 'Premium',
        isPayment: 'Done',
      },
      {
        id: 12,
        fullName: 'Seth Hallam',
        subscriptionType: 'Free',
        isPayment: 'Not Done',
      },
      {
        id: 13,
        fullName: 'Yoko Pottie',
        subscriptionType: 'Free',
        isPayment: 'Not Done',
      },
      {
        id: 14,
        fullName: 'Maximilianus Krause',
        subscriptionType: 'Premium',
        isPayment: 'Pending',
      },
      {
        id: 15,
        fullName: 'Zsazsa McCleverty',
        subscriptionType: 'Standard',
        isPayment: 'Done',
      },
      {
        id: 16,
        fullName: 'Bentlee Emblin',
        subscriptionType: 'Premium',
        isPayment: 'Done',
      },
      {
        id: 17,
        fullName: 'Brockie Myles',
        subscriptionType: 'Standard',
        isPayment: 'Pending',
      },
      {
        id: 18,
        fullName: 'Bertha Biner',
        subscriptionType: 'Premium',
        isPayment: 'Done',
      },
      {
        id: 19,
        fullName: 'Travus Bruntjen',
        subscriptionType: 'Standard',
        isPayment: 'Pending',
      },
      {
        id: 20,
        fullName: 'Wesley Burland',
        subscriptionType: 'Standard',
        isPayment: 'Pending',
      }
    ];
  }
  